import { ApiDocumentFile } from '../api/api-types/document.api';
import { DocumentFile } from '../api/app-types/document.app';

/**
 * This is mock data to mock a document or multiple documents.
 */

export const mockDocuments: DocumentFile[] = [
	{
		id: 'id1',
		name: 'Beispiel Dokument.pdf',
		location: 'https://example.com/document.pdf',
		mimeType: 'application/pdf',
		size: 4 * 1024 * 1024,
	},
	{
		id: 'id2',
		name: 'Nachweis.pdf',
		location: 'https://example.com/nachweis.pdf',
		mimeType: 'application/pdf',
		size: 5 * 1024 * 1064,
	},
	{
		id: 'id3',
		name: 'Bild.png',
		location: 'https://example.com/bild.png',
		mimeType: 'image/png',
		size: 3 * 743 * 1024,
	},
];

export const mockDocument = mockDocuments[0];
export const mockImage = mockDocuments[2];

export const mockApiDocuments: ApiDocumentFile[] = [
	{
		fileId: 'id1',
		fileName: 'Beispiel Dokument.pdf',
		url: 'https://example.com/document.pdf',
		mimeType: 'application/pdf',
		fileByteLength: 5 * 1024 * 1024,
	},
	{
		fileId: 'id2',
		fileName: 'Nachweis.pdf',
		url: 'https://example.com/nachweis.pdf',
		mimeType: 'application/pdf',
		fileByteLength: 5 * 1024 * 1064,
	},
	{
		fileId: 'id3',
		fileName: 'Bild.png',
		url: 'https://example.com/bild.png',
		mimeType: 'image/png',
		fileByteLength: 3 * 743 * 1024,
	},
];
